<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Subscription Videos">
      <div class="row">
        <div class="col-md-12 mb-2" align="right">
          <b-button v-b-modal.modal-1 variant="success" v-on:click="clear()"
            >Insert Videos</b-button
          >
        </div>
      </div>

      <b-table-simple responsive bordered striped table-class="table-vcenter">
        <b-thead v-if="videoDatas != ''">
          <b-tr>
            <b-th class="text-center">S.NO</b-th>
            <b-th class="text-center">Topic</b-th>
            <b-th class="text-center">Sub Topic</b-th>
            <b-th class="text-center">Selected Videos</b-th>
            <b-th class="text-center">Action</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(videoData, index) in videoDatas" :key="videoData">
            <b-td class="text-center"> {{ index + 1 }} </b-td>
            <b-td class="text-center"> {{ videoData[0] }} </b-td>
            <b-td class="text-center">{{ videoData[1] }}</b-td>
            <b-td class="text-center">{{ videoData[2] }}</b-td>
            <b-td class="text-center">
              <b-btn-group>
                <b-button
                  size="sm"
                  variant="alt-primary"
                  v-b-modal.modal-1
                  v-on:click="edited(index)"
                >
                  <i class="fa fa-fw fa-pencil-alt"></i>
                </b-button>
                <b-button
                  size="sm"
                  variant="alt-primary"
                  v-on:click="deleted(index)"
                >
                  <i class="fa fa-fw fa-times"></i>
                </b-button> </b-btn-group
            ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <b-modal
        id="modal-1"
        ref="modalone"
        title="Insert Videos"
        size="xl"
        @ok="addNewRow()"
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        ok-title="Insert"
        ok-variant="success"
        cancel-variant="danger"
      >
        <template #modal-footer v-if="modal == 'edit'">
          <b-button v-on:click="cancel()" variant="danger">Cancel</b-button>
          <b-button variant="success" v-on:click="saveChanges()"
            >Save Changes</b-button
          >
        </template>

        <div class="row">
          <div class="col-md-6 form-group">
            Topic
            <b-form-select v-model="topic" required>
              <option value="Quantitative">Quantitative</option>
              <option value="Verbal">Verbal</option>
              <option value="Reasoning">Reasoning</option>
            </b-form-select>
          </div>
          <div
            class="col-md-6 form-group"
            v-if="topic != ''"
            v-on:change="optionSelect()"
          >
            Sub Topic
            <b-form-select v-model="subTopic">
              <option value="Quantitative 1" v-if="topic == 'Quantitative'">
                Quantitative 1
              </option>
              <option value="Quantitative 2" v-if="topic == 'Quantitative'">
                Quantitative 2
              </option>
              <option value="Quantitative 3" v-if="topic == 'Quantitative'">
                Quantitative 3
              </option>

              <option value="Verbal 1" v-if="topic == 'Verbal'">
                Verbal 1
              </option>
              <option value="Verbal 2" v-if="topic == 'Verbal'">
                Verbal 2
              </option>
              <option value="Verbal 3" v-if="topic == 'Verbal'">
                Verbal 3
              </option>

              <option value="Reasoning 1" v-if="topic == 'Reasoning'">
                Reasoning 1
              </option>
              <option value="Reasoning 2" v-if="topic == 'Reasoning'">
                Reasoning 2
              </option>
              <option value="Reasoning 3" v-if="topic == 'Reasoning'">
                Reasoning 3
              </option>
            </b-form-select>
          </div>

          <div class="col-md-12 form-group" v-if="subTopic && videos != ''">
            Select Videos For Subscription
            <b-list-group
              v-for="(video, index) in videos"
              :key="index"
              class="border border-danger mb-1"
            >
              <b-list-group-item v-on:click="addVideo(index)" button>{{
                videos[index]
              }}</b-list-group-item>
            </b-list-group>
          </div>

          <div class="col-md-12 form-group" v-if="selectedVideos != ''">
            Selected Videos For Subscription
            <b-list-group
              v-for="(selected, index) in selectedVideos"
              :key="index"
              class="border border-success mb-1"
            >
              <b-list-group-item v-on:click="removeVideo(index)" button>{{
                selectedVideos[index]
              }}</b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </b-modal>

      <div class="text-center" v-if="videoDatas != ''">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4 mb-4"
          variant="success"
          href="/#/backend/forms/add-practice-test"
          >Next</b-button
        >
      </div>
    </base-block>
    <br />
  </div>
</template>

<script>
export default {
  methods: {
    cancel() {
      this.$refs.modalone.hide();
    },
    saveChanges() {
      this.videoDatas[this.requiredIndex][0] = this.topic;
      this.videoDatas[this.requiredIndex][1] = this.subTopic;
      this.videoDatas[this.requiredIndex][2] = this.selectedVideos;
      this.videoDatas[this.requiredIndex][3] = this.videos;
      this.$refs.modalone.hide();
      (this.topic = ""),
        (this.subTopic = ""),
        (this.selectedVideos = ""),
        (this.videos = "");
    },
    edited(index) {
      this.modal = "edit";
      this.requiredIndex = index;
      this.topic = this.videoDatas[index][0];
      this.subTopic = this.videoDatas[index][1];
      this.selectedVideos = this.videoDatas[index][2];
      this.videos = this.videoDatas[index][3];
    },

    deleted(index) {
      //this.videoDatas.splice(index, 1)
      this.$delete(this.videoDatas, index);
    },
    clear() {
      this.modal = null;
      this.videos = [];
      this.selectedVideos = [];
      (this.topic = ""), (this.subTopic = "");
    },
    addNewRow() {
      this.videoDatas.push([
        this.topic,
        this.subTopic,
        this.selectedVideos,
        this.videos,
      ]);
    },
    optionSelect() {
      this.videos = [...this.temp];
      this.selectedVideos = [];
    },
    addVideo(index) {
      this.selectedVideos.push(this.videos[index]);
      this.videos.splice(index, 1);
    },
    removeVideo(index) {
      this.videos.push(this.selectedVideos[index]);
      this.selectedVideos.splice(index, 1);
    },
  },
  data() {
    return {
      requiredIndex: 0,
      modal: null,
      subTopic: "",
      videoDatas: [],
      topic: "",
      temp: [
        {
          sno: 1,
          topic: "Numbers",
          name: "QA 1",
          description: "Quantitative Aptitude",
          videoUrl: "localhost:8000",
          videoStatus: "Free",
          labelVariant: "success",
          labelText: "Active",
        },
        {
          sno: 2,
          topic: "Data Sufficiency",
          name: "QA 2",
          description: "Arithmetic & Geometric Progression",
          videoUrl: "localhost:9000",
          videoStatus: "Paid",
          labelVariant: "danger",
          labelText: "Deactive",
        },
        {
          sno: 3,
          topic: "AP & GP",
          name: "QA 3",
          description: "Numbers",
          videoUrl: "localhost:8080",
          videoStatus: "Paid",
          labelVariant: "danger",
          labelText: "Deactive",
        },
        {
          sno: 4,
          topic: "Quantitative Aptitude",
          name: "QA 4",
          description: "Data Sufficiency",
          videoUrl: "localhost:5000",
          videoStatus: "Free",
          labelVariant: "success",
          labelText: "Active",
        },
      ],
      videos: [],
      selectedVideos: [],
    };
  },
};
</script>